var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"bg-variant":"light","header":"Users","header-bg-variant":"dark","header-text-variant":"white"}},[_c('b-tabs',{attrs:{"lazy":"","title":"Users"}},[_c('users_list',{attrs:{"fields":_vm.user_fields}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }